export default __webpack_public_path__ + "static/media/TasksInactiveLight.011ad4fe.svg";